import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'
import router from '@/router/index.js'

Vue.use(Vant)

Vue.config.productionTip = false

let echarts = require('echarts')

let BASE_URL_SERVER = "https://api.srcclims.com";
let STATIC_URL_SERVER = "https://www.srcclims.com/";

// let BASE_URL_SERVER = "http://192.168.1.180:8080";
// let STATIC_URL_SERVER = "http://192.168.1.180/";


Vue.prototype.$echarts = echarts
axios.defaults.withCredentials=false
Vue.prototype.$axios = axios
Vue.prototype.$url = BASE_URL_SERVER
Vue.prototype.$static_url = STATIC_URL_SERVER

Vue.prototype.$fileUrlFac = function(url,pid){
  if(url&&url.indexOf('http')===-1){
    return STATIC_URL_SERVER + url +'?id=' + pid;
  }else{
    return url;
  }
}

Vue.prototype.$fileUrlFacWithoutRight = function(url){
  if(url.indexOf('http')===-1){
  return STATIC_URL_SERVER + url;}
  else{
    return url;
  }
}   

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

export {BASE_URL_SERVER}
